enum AccordionStateEnum {
	CELLPHONE = 'accordion-cellPhone',
	BANK = 'accordion-bank',
	ADDRESS = 'accordion-address',
	EMAIL = 'accordion-email',
}

type AccordionStatesType = AccordionStateEnum;

interface FormAccordionStore {
	type: AccordionStatesType | undefined;
	setType: (type: AccordionStatesType) => void;
	reset: () => void;
}

export type {AccordionStatesType, FormAccordionStore};
export {AccordionStateEnum};
